import type { PreviewLog } from 'api/types';
import { postMessage } from 'utils/postMessage';

export const postForethoughtWidgetPreviewLogMessage = (
  conversationId?: string,
  previewLogs?: PreviewLog[],
) => {
  postMessage({
    conversationId: conversationId,
    event: 'forethoughtWidgetPreviewLogsEvent',
    previewLogs: previewLogs,
  });
};

export const postForethoughtWidgetPreviewErrorMessage = (error: unknown) => {
  let errorTitle = 'An error occurred while executing the workflow';
  let errorMessage = undefined;

  if (error instanceof Error) {
    if (
      error.message.startsWith(
        'No condition fulfills the transition for step_id',
      )
    ) {
      errorTitle = 'Condition step has no valid transition to go to';
      errorMessage =
        'Please check context variables are defined or add an Otherwise branch';
    }
  }

  postForethoughtWidgetPreviewLogMessage(undefined, [
    {
      log_type: 'warning',
      message: errorMessage,
      title: errorTitle,
    },
  ]);
};
